import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "../api.config";

export const teamMemberApi = createApi({
  reducerPath: "teamMemberApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["TeamMember"],
  endpoints: (builder) => ({
    getAllMembers: builder.query({
      query: (params) => ({ url: "/team-members", params }),
      transformResponse: (response) =>
        response.data || { members: [], teamStats: {} },
      providesTags: ["TeamMember"],
    }),
    createMember: builder.mutation({
      query: (data) => ({
        url: "/team-members",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["TeamMember"],
    }),
    updateMember: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/team-members/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["TeamMember"],
    }),
    deleteMember: builder.mutation({
      query: (id) => ({
        url: `/team-members/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["TeamMember"],
    }),
    getMemberTasks: builder.query({
      query: (id) => `/team-members/${id}/tasks`,
      transformResponse: (response) => response.data || { tasks: [], member: null },
      providesTags: (r, e, id) => [{ type: "TeamMember", id }],
    }),
  }),
});

export const {
  useGetAllMembersQuery,
  useCreateMemberMutation,
  useUpdateMemberMutation,
  useDeleteMemberMutation,
  useGetMemberTasksQuery,
} = teamMemberApi;
